import { useEffect, useState } from 'react'

import { mixOther } from 'api/mixOther'

type Home = {
  meta_title: string;
  meta_description: string;
  meta_keywords: string;
  images_vocher_1: string;
  images_vocher_2: string;
  images_vocher_3: string;
  images_vocher_4: string;
  link_vocher_1: string;
  link_vocher_2: string;
  link_vocher_3: string;
  link_vocher_4: string;

};

export default function UuDaiHangHang() {
    const [home, setHome] = useState<Home | null>(null)
    
    useEffect(() => {
        const loadOther = async () => {
            const res = await mixOther("sshome","vi")
                if (!res?.status || !res.data?.json) {
                return;
            }

            try {
                const parsed = JSON.parse(res.data.json);
                setHome((prev) => ({ ...prev, ...parsed }));
            } catch (error) {
                console.error("Failed to parse setting JSON:", error);
            }
        };

        loadOther();
    }, [])

    // useEffect(()=> {
    //     console.log(home)
    // },[home])
    return (
        <div className="styles_container___VyYb !bg-transparent">
            <div className="MuiContainer-root styles_boxContainer__xZE8l MuiContainer-maxWidthLg">

                <div className="styles_companyIntroduction__h04I7">
                    <div className="styles_title__JlrYL">

                        <div className="styles_companyTitle__W3WKs">
                            Ưu đãi hàng hãng
                            <span className="styles_branchName__QPk2S"></span>
                        </div>

                        <svg
                            className="styles_vector__ifrV4"
                            width="202"
                            viewBox="0 0 200 4"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M0 2H200"
                                stroke="#005C29"
                                strokeWidth="4"
                                strokeLinecap="round"
                            />
                        </svg>

                    </div>
                </div>

                <div className="styles_miniBannerBlockWrapper__FcCrm">
                    <div className="styles_gridImagesWrapper__C5NLi">
                        <div className="styles_gridImages__AfRal">

                            {/* Banner 1 */}
                            { home?.images_vocher_1 !== '' && (
                                <div className="styles_miniBannerImageSize4_1__ohXmv MuiBox-root css-0">
                                    <a
                                        href={home?.link_vocher_1}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "block",
                                                overflow: "hidden",
                                                inset: 0
                                            }}
                                        >
                                            <img
                                                src={home?.images_vocher_1}
                                                decoding="async"
                                                loading="lazy"
                                                data-nimg="fill"
                                                alt=""
                                                style={{
                                                    inset: 0,
                                                    margin: "auto",
                                                    minWidth: "100%",
                                                    maxWidth: "100%",
                                                    minHeight: "100%",
                                                    maxHeight: "100%",
                                                    objectFit: "cover"
                                                }}
                                            />
                                        </span>
                                    </a>
                                </div>
                            )}
                            

                            {/* Banner 2 */}
                            {home?.images_vocher_2 !== '' && (

                                <div className="styles_miniBannerImageSize4_2__T3yZS MuiBox-root css-0">
                                    <a
                                        href={home?.link_vocher_2}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "block",
                                                overflow: "hidden",
                                                position: "absolute",
                                                inset: 0
                                            }}
                                        >
                                            <img
                                                src={home?.images_vocher_2}
                                                decoding="async"
                                                loading="lazy"
                                                data-nimg="fill"
                                                alt=""
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    margin: "auto",
                                                    minWidth: "100%",
                                                    maxWidth: "100%",
                                                    minHeight: "100%",
                                                    maxHeight: "100%",
                                                    objectFit: "cover"
                                                }}
                                            />
                                        </span>
                                    </a>
                                </div>
                            )}

                            {/* Banner 3 */}
                            {home?.images_vocher_3 !== '' && (

                                <div className="styles_miniBannerImageSize4_3__OP7YU MuiBox-root css-0">
                                    <a
                                        href={home?.link_vocher_3}
                                        rel="noopener noreferrer"
                                    >
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "block",
                                                overflow: "hidden",
                                                position: "absolute",
                                                inset: 0
                                            }}
                                        >
                                            <img
                                                src={home?.images_vocher_3}
                                                decoding="async"
                                                loading="lazy"
                                                data-nimg="fill"
                                                alt=""
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    margin: "auto",
                                                    minWidth: "100%",
                                                    maxWidth: "100%",
                                                    minHeight: "100%",
                                                    maxHeight: "100%",
                                                    objectFit: "cover"
                                                }}
                                            />
                                        </span>
                                    </a>
                                </div>
                            )}

                            {/* Banner 4 */}
                             { home?.images_vocher_4 !== null  && (

                                <div className="styles_miniBannerImageSize4_4__mO1uG MuiBox-root css-0">
                                    <a
                                        href={home?.link_vocher_4}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "block",
                                                overflow: "hidden",
                                                position: "absolute",
                                                inset: 0
                                            }}
                                        >
                                            <img
                                                src={home?.images_vocher_4}
                                                decoding="async"
                                                loading="lazy"
                                                data-nimg="fill"
                                                alt=""
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    margin: "auto",
                                                    minWidth: "100%",
                                                    maxWidth: "100%",
                                                    minHeight: "100%",
                                                    maxHeight: "100%",
                                                    objectFit: "cover"
                                                }}
                                            />
                                        </span>
                                    </a>
                                </div>
                             )}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}